import styles from '../../styles';
import { translate } from '../../locales/i18n';

const AuditorMenuItems = (_user) => ({
  style: styles.nav.avatarContainerConsumer,
  mainMenuItems: [
    {
      text: translate('Audit Home'),
      link: '/auditor',
    },
    {
      text: translate('Pending Users'),
      link: '/pendingusers',
    },
    {
      text: translate('Pending AI Agents'),
      link: '/pendingapps',
    },
    {
      text: translate('Pending Reviews'),
      link: '/pendingreviews',
    },
    {
      text: translate('Home'),
      link: '/',
    },
  ],
  collapsableMenuItems: [
  ],
});

export default AuditorMenuItems;
